import get from 'lodash/get';
import { useMemo } from 'react';
import { getClientRequestHeaders } from './headers';
import { getApiEndpoint } from './url';

export const log = ({
  eventType,
  message = '',
  params = {},
  sessionId = '',
  type,
}) => {
  fetch(`${getApiEndpoint()}/api/${eventType}`, {
    method: 'POST',
    headers: {
      ...getClientRequestHeaders(sessionId),
    },
    body: JSON.stringify({
      journeyStageCause: type,
      ...(message ? { message } : {}),
      params,
    }),
  }).catch(console.error.bind(console));
};

const useLog = ({
  eventType,
  message = '',
  params = {},
  sessionId = '',
  type,
}) => {
  useMemo(() => {
    log({
      eventType,
      message,
      params,
      sessionId,
      type,
    });
  }, [type, sessionId, get(params, 'journeyStageCause', '')]);
};

export const useLogInfo = parameters => {
  useLog({ ...parameters, eventType: 'log' });
};

export const useLogError = parameters => {
  useLog({ ...parameters, eventType: 'error' });
};
